'use client';

import React from 'react';

import { IBlock } from '@/lib/types';
import { splitBlock } from '@/lib/blockUtils';

import { BlockRow } from './BlockRow';

interface IBlockProps {
  blockIndex: number;
  /** Its first card is the page's likely LCP element and is fetched eagerly. */
  isPrimaryPostBlock?: boolean;
  /** Below the primary block: its images defer to that block's thumbnail. */
  isBelowPrimaryPostBlock?: boolean;
  block: IBlock;
  showTitle?: boolean;
}

export const Block: React.FC<IBlockProps> = ({
  block,
  blockIndex,
  isPrimaryPostBlock = false,
  isBelowPrimaryPostBlock = false,
  showTitle = true,
}) => {
  const splitBlocks = splitBlock(block);

  return (
    <>
      {splitBlocks.map((blockRow: IBlock, index: number) => (
        <BlockRow
          key={`${blockIndex}-${index}`}
          {...blockRow}
          blockType={blockRow.type}
          blockIndex={`${blockIndex}-${index}`}
          isPrimaryPostBlock={isPrimaryPostBlock && index === 0}
          isBelowPrimaryPostBlock={isBelowPrimaryPostBlock}
        />
      ))}
    </>
  );
};
